const MOStringUtils = (require("./utils/MOStringUtils"));
const MOObjectUtils = (require("./utils/MOObjectUtils"));

// export  const JWTPayloadValue = typeof  number | number[] | string | string[] | Record<string, number | number[] | string | string[]> | Record<string, number | number[] | string | string[]>[];
// export  const  JWTPayload = typeof Record<string, JWTPayloadValue>;
export default class JWT {
    constructor() {
        this.header = {};
        this.payload = {};
        this.sign = "";
    }

    isEmpty() {
        if (MOObjectUtils.default.isEmpty(this.header)) {
            return true;
        }
        if (MOObjectUtils.default.isEmpty(this.payload)) {
            return true;
        }
        return false;
    }
    getEncodedJwt() {
        let encodedHeader = MOStringUtils.default.base64encode(JSON.stringify(this.header));
        let encodedPayload = MOStringUtils.default.base64encode(JSON.stringify(this.payload));
        return encodedHeader + '.' + encodedPayload;
    }
    parseStringComponent(component) {
        let decoded = MOStringUtils.default.base64decode(component);
        return JSON.parse(decoded);
    }
    getAlg() {
        return this.header.alg;
    }
    getExpiry() {
        let exp = this.payload.exp.toString();
        return new Date(parseInt(exp) * 1000);
    }
    getNbf() {
        let nbf = this.payload.nbf.toString();
        return new Date(parseInt(nbf) * 1000);
    }
    getIat() {
        let iat = this.payload.iat.toString();
        return new Date(parseInt(iat) * 1000);
    }
    setHeader(header) {
        this.header = header;
    }
    setPayload(payload) {
        if (MOStringUtils.default.isString(payload)) {
            payload = this.parseStringComponent(payload);
        }
        this.payload = payload;
    }
    setSign(sign) {
        this.sign = sign;
    }
    getSign() {
        return this.sign;
    }
    getHeader() {
        return this.header;
    }
    getPayload() {
        return this.payload;
    }
}
//# sourceMappingURL=JWT.js.map